<template>
  <div v-for="file in attachFiles" :key="file.id ?? file.name" class="input-group input-group-solid mb-2" @click="showInvoice(file)">
    <span class="input-group-text clickab" v-html="getFileIcon(file.name, {type: 'i', size: '2.4em', className: 'me-2'})" style="background-color: var(--bs-semi-light-primary);">
    </span>
    <div
      style="background-color: var(--bs-semi-light-primary);"
      :title="file.name"
      class="text-hover-primary form-control border-left-0 d-flex align-items-center text-center clickab"
    >
      <template v-if="isViewable(file.type)">
        <div class="text-truncate">{{ file.name }}</div>
      </template>
      <template v-else>
        <a :href="file.url" :download="file.name" target="_blank" class="text-truncate text-primary">
          {{ file.name }}
        </a>
      </template>
    </div>
    <span v-if="remove" class="input-group-text" @click.stop="deleteFile(file)">
      <i class="bi bi-x fs-1 text-danger clickab"></i>
    </span>
  </div>

  <div class="modal fade" id="invoiceModal" data-backdrop="static" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" :class="modalType" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="font-weight-bolder text-dark mb-1" style="font-size: 20px;">
            {{ invoice?.name }}
          </h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="modal-body" v-if="invoice && isViewable(invoice.type)">
          <iframe v-if="!invoice.type?.startsWith('image')" :src="displayUrl" :key="displayUrl" width="100%" height="678"></iframe>
          <div v-else class="col-md-12 d-flex justify-content-center align-items-center">
            <img :src="displayUrl" :alt="invoice.name" class="img" style="width: 100%; height: 600px; object-fit: contain;">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light" @click="closeModal">
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from "vue";
import { useSwal } from "@/composables/useSwal";
import i18n from "@/plugins/i18n";
import {getFileIcon} from "@/mixins/Helpers";

const props = defineProps({
  attachFiles: { type: Array, default: () => [] },
  isDisabled: { type: Boolean, default: false },
  remove: { type: Boolean, default: true },
  modalType: { type: String, default: 'modal-lg' }
});

const emits = defineEmits(['remove']);
const invoice = ref(null);
const { showSwal } = useSwal();

const displayUrl = computed(() => invoice.value?.url ? `${invoice.value.url}?t=${Date.now()}` : '');

function showInvoice(file) {
  if (isViewable(file.type)) {
    invoice.value = file;
    setTimeout(() => {
      $('#invoiceModal').modal('show');
    }, 0);
  } else {
    window.open(file.url, '_blank');
  }
}

function closeModal() {
  $('#invoiceModal').modal('hide');
}

function isViewable(type) {
  const viewableTypes = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/svg+xml',
    'text/plain',
    'text/html'
  ];
  return viewableTypes.includes(type);
}



function deleteFile(file) {
  showSwal(
    i18n.global.t('file.swal.title'),
    i18n.global.t('file.swal.delete_message')
  ).then(async (result) => {
    if (result.value) {
      emits('remove', file);
    }
  });
}
</script>

<style scoped>

.icon-circle-light {
  background-color: var(--bs-light-primary);
  color: var(--bs-primary);
  border-radius: 50%;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: -12px;
}

.clickab{
  cursor: pointer;
}
</style>
